import { ASYNC_REQUEST, ASYNC_SUCCESS, ASYNC_FAIL } from '../actions'

const defaultState = {
  createProject: false,
  editProject: false,
  fetchProjects: false,

  createContact: false,
  editContact: false,
  fetchContacts: false,

  addContactLog: false,
  fetchContactLogs: false,

  addUser: false,
  updateUserSettings: false,

  fetchStats: false,
  fetchAppointments: false,

  addCompany: false
}

const loading = (state = defaultState, { type, payload }) => {
  switch (type) {
    case ASYNC_REQUEST: {
      return {
        ...state,
        [payload.actionName]: true
      }
    }

    case ASYNC_SUCCESS:
    case ASYNC_FAIL: {
      return {
        ...state,
        [payload.actionName]: false
      }
    }

    default:
      return state
  }
}

export default loading



// WEBPACK FOOTER //
// ./src/reducers/loading.js